module.exports = __webpack_public_path__ + "static/media/participanti-icon.e7f51134.svg";